import axios from '~/common/plugins/axios.js'
/* 产品下通用数据，防止重复请求 */
export const state = () => ({
  // 所有厂牌
  brandList: [],

  // 所有分类
  categList: [],

  // 所有产品组（系列）
  groupList: [],
  // 父类列表
  parentCategoryList: [],

  currentSkuType: '',
  hscodeCache: {}

})
//树形数据处理
const handleTreeData = function (data) {
  let target = data
  for (let i = 0; i < data.length; i++) {
    let ele = data[i]
    data[i].label = ele.short_name
    if (ele.child && ele.child.length > 0) {
      target[i].children = data[i].child //child-->children
      target[i].child && delete target[i].child
      target[i].parent_id && delete target[i].parent_id
      target[i].short_name && delete target[i].short_name
      handleTreeData(target[i].children)
    } else if (ele.child == null || ele.child.length == 0) {
      target[i].child && delete target[i].child
      target[i].parent_id && delete target[i].parent_id
      target[i].short_name && delete target[i].short_name
    }
  }
  return target
}
export const mutations = {
  setBrandList(state, data) {
    state.brandList = data;
  },
  setCategList(state, data) {
    state.categList = data;
  },
  setGroupList(state, data) {
    state.groupList = data;
  },
  set_parentCategoryList(state, v) {
    const categoryList = handleTreeData(v)
    state.parentCategoryList = categoryList;
  },
  set_currentSkuType(state, data) {
    state.urrentSkuType = data;
  },
  set_hscodeCache(state, v) {
    state.hscodeCache = v
  }
}

export const actions = {
  // 获取父分类列表
  async getParentCategoryList({ state, commit, dispatch }, payload) {
    //payload.current_id每次不一样，列表需要更新
    const res = await axios.$post('/rest/erp/product/v3/categories/getcategtree', {...payload});
    if (!res || (res && res.code !== 200)) {
      return [];
    }
    commit("set_parentCategoryList", res.data);
    return res.data;

  },
  async getBrandList({ state, commit }, parameter) {
    if (state.brandList.length > 0) {
      return state.brandList;
    } else {
      const { code, data } = await axios.$post('/rest/erp/product/v3/brands/lookup', parameter);
      if (code !== 200) return [];

      const brandList = data.list.map(({ id, short_name }) => ({ id, name: short_name }));

      commit('setBrandList', brandList);
      return brandList;
    }
  },
  async getCategList({ state, commit }, parameter) {
    if (state.categList.length > 0) {
      return state.categList;
    } else {
      const { code, data } = await axios.$post('/rest/erp/product/v3/categories/lookup', parameter);
      if (code !== 200) return [];

      const categList = data.list.map(({ id, short_name }) => ({ id, name: short_name }));

      commit('setCategList', categList);
      return categList;
    }
  },
  async getGroupList({ state, commit }, parameter) {
    if (state.groupList.length > 0) {
      return state.groupList;
    } else {
      const { code, data } = await axios.$post('/rest/erp/product/v3/productGroups/query', parameter);
      if (code !== 200) return [];

      const groupList = data.list.map(({ id, name }) => ({ id, name }));

      commit('setGroupList', groupList);
      return groupList;
    }
  },
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
